import { render, staticRenderFns } from "./styleSelector.vue?vue&type=template&id=27b4a9ce&scoped=true"
import script from "./styleSelector.vue?vue&type=script&lang=js"
export * from "./styleSelector.vue?vue&type=script&lang=js"
import style0 from "./styleSelector.vue?vue&type=style&index=0&id=27b4a9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b4a9ce",
  null
  
)

export default component.exports